/**
 * @param {string} fileName
 * @param {string} url
 */
export default function downloadUrl(fileName, url) {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();

    a.remove();
}